import styled from 'styled-components';
import { Button } from 'components';
import { Flex } from '@chakra-ui/layout';

export const Container = styled(Flex)`
  grid-gap: 1rem;

  span {
    display: none;
  }
`;

export const DownloadBtn = styled(Button)`
  /* width: 5rem; */
  /* width: 30rem; */
  height: 40px;
  min-width: unset;
  min-height: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
  border: solid 1.9px black;
  border-radius: 5px;
  padding: 0;
  padding-inline: 1.2rem;
`;
